import { useEffect } from "react";
import { Link, useNavigate } from "react-router";

import { Column, TopbarContainer, TopbarTitle } from "@/components";
import { DemoConfigsForm } from "@/components/tools/DemoConfigsForm";

import { useSetTitle } from "@/hooks/useSetTitle";
import { mixpanelUtils } from "@/lib/mixpanel/mixpanel";
import { MIXPANEL_SCREENS, MIXPANEL_SUBSCREENS } from "@/lib/mixpanel/types";
import { novaClient } from "@/lib/trpc";
import { CreateOrUpdateDemoConfigRequest } from "@/types";

export const ToolsDemoConfigsCreatePage = () => {
  const navigate = useNavigate();

  const { mutate: createDemoConfig, isPending } =
    novaClient.internal.admin.demoConfigs.create.useMutation({
      onSuccess: () => {
        void navigate("/tools/demo-configs");
      },
    });

  useSetTitle({
    title: "Tools | Demo Configs | Create",
  });

  useEffect(() => {
    mixpanelUtils.trackScreenView(MIXPANEL_SCREENS.DEMO_CONFIGS, {
      subScreenName: MIXPANEL_SUBSCREENS.CREATE,
    });
  }, []);

  const handleSubmit = (data: CreateOrUpdateDemoConfigRequest) => {
    createDemoConfig(data);
  };

  return (
    <Column className="h-svh">
      <TopbarContainer>
        <TopbarTitle className="!text-slate-500">
          <Link className="hover:underline" to="/tools/demo-configs">
            Demo Configs
          </Link>{" "}
          / <span className="text-slate-700">Create</span>
        </TopbarTitle>
      </TopbarContainer>
      <div className="flex-1 overflow-y-auto p-6">
        <DemoConfigsForm
          isSubmitting={isPending}
          onSubmit={handleSubmit}
          submitButtonText="Create"
        />
      </div>
    </Column>
  );
};
